import { css } from "@emotion/react";
import { formatRelativeDateTime } from "@hl/shared-features/lib/utils/format";
import { MantineTheme } from "@mantine/core";
import { Editor, TraitProperties } from "grapesjs";
import { renderToStaticMarkup } from "react-dom/server";

import { HL_BASE_COMPONENT_TYPE } from "./BaseHLComponentPlugin";

const HL_TIMER_COMPONENT_TYPE = "hl-timer";

type Props = {
  date: string;
  endMessage: string;
  design: "default" | "simple";
};

const getComponentStyles = (/*theme: MantineTheme*/) => {
  const componentStyles = css`
    .hl-timer {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
    }
  `;

  return componentStyles.styles;
};

const ViewComponent = (
  props: Props & {
    theme: MantineTheme;
  }
) => {
  const { date, endMessage } = props;
  let time = "Invalid date";
  try {
    time = formatRelativeDateTime(+date, Date.now(), 0, undefined, true);

    if (+date <= Date.now()) {
      time = endMessage;
    }
  } catch (e) {
    console.error("Invalid date", e);
  }

  // console.log("ViewComponent", { date, time });

  return (
    <div className="hl-timer">
      <p>{time}</p>
    </div>
  );
};

export const HLTimerPlugin = (theme: MantineTheme) => (editor: Editor) => {
  const { Blocks, Components } = editor;

  Components.addType(HL_TIMER_COMPONENT_TYPE, {
    extend: HL_BASE_COMPONENT_TYPE,
    isComponent() {
      return false;
    },
    model: {
      defaults: {
        type: HL_TIMER_COMPONENT_TYPE,
        name: "HL Timer",
        tagName: "div",
        attributes: {
          "data-gjs-type": HL_TIMER_COMPONENT_TYPE,
        },
        traits: [
          {
            type: "number",
            name: "date",
            label: "Date",
            default: "Enter the date",
            required: true,
            changeProp: true,
          },
          {
            type: "text",
            name: "endMessage",
            label: "End message",
            default: "Enter the message shown after the timer ends",
            required: true,
            changeProp: true,
          },
          {
            type: "select",
            name: "design",
            label: "Design",
            default: "default",
            changeProp: true,
            options: [
              { id: "default", label: "Default" },
              // { id: "simple", label: "Simple" },
            ],
          },
          // {
          //   type: "number",
          //   name: "maxImageHeight",
          //   label: "Max image height",
          //   units: ["px"],
          //   min: 0,
          //   default: "auto",
          //   changeProp: true,
          // },
        ] as TraitProperties[],
        stylable: [],
        // Traits from changeProp: true
        date: "0",
        endMessage: "",
        design: "default",
      },
    },
    view: {
      onRender({ el, model }) {
        console.log("HLTimer [onRender]", { el, model });
        //@ts-ignore
        const props = this.model.toJSONData();
        el.innerHTML = renderToStaticMarkup(
          <ViewComponent {...props} theme={theme} />
        );
      },
    },
  });

  Blocks.add(HL_TIMER_COMPONENT_TYPE, {
    label: "Timer",
    category: "Highlight",
    content: { type: HL_TIMER_COMPONENT_TYPE },
  });
};

HLTimerPlugin.type = HL_TIMER_COMPONENT_TYPE;
HLTimerPlugin.getStyles = getComponentStyles;
